import React from 'react';
import {
  Card, Typography, Box, CardContent, Grid, Divider,
} from '@material-ui/core';
import MetalBin from './MetalBin';
import type { IRepairItem } from '../marking/MarkingInterfaces';

const MetalBinContainer: React.FC<{
  repairItems:IRepairItem[],
  sendNotification: (messageType: 'Empty Bin' | 'Low Stock', message: string) => void,
  setEmptyBin: (emptyBin: string) => void
  setEmptyItemBin: (emptyBinItem: IRepairItem) => void
}> = ({
  repairItems, sendNotification, setEmptyBin, setEmptyItemBin,
}) => {
  const MetalBinMap = (
    repairItems?.map((repairItem) => (
      <Grid item lg={6} xs={12}>
        <MetalBin
          repairItem={repairItem}
          sendNotification={sendNotification}
          setEmptyBin={setEmptyBin}
          setEmptyItemBin={setEmptyItemBin}
        />
      </Grid>
    ))
  );

  return (
    <Card>
      <Box ml={2} my={2}>
        <Typography variant="h5" style={{ fontSize: '1.125rem' }}>{'Pull Sizing Stock From These Bins'}</Typography>
      </Box>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={2}
        >
          {MetalBinMap}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MetalBinContainer;
